function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  opacity: 0.8
}, React.createElement("path", {
  fill: "#FFF",
  d: "M51 15h-4v-5c0-1.1-.9-2-2-2H2c-1.1 0-2 .9-2 2v43c0 1.1.9 2 2 2h44.5c.9 0 1.6-.6 1.9-1.4L53 39.5V17c0-1.1-.9-2-2-2z",
  opacity: 0.4
}), React.createElement("path", {
  fill: "#FFF",
  d: "M46 36H9c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h37c.6 0 1 .4 1 1v34c0 .6-.4 1-1 1z"
}), React.createElement("g", {
  fill: "#3D3234"
}, React.createElement("path", {
  d: "M37.1 29.6c-.3 0-.5-.1-.7-.3L23.1 15.9 12 27c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l11.7-11.8c.4-.4 1-.4 1.4 0l14 14c.4.4.4 1 0 1.4-.1.3-.4.4-.6.4z"
}), React.createElement("path", {
  d: "M44.4 27.3c-.3 0-.5-.1-.7-.3l-6-6-3.4 3.4c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l3.5-3.5.5-.5.1-.1c.5-.4.9-.5 1.4 0l.2.2 6.5 6.5c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3zm-9-14.8c-2.3 0-4.2-1.9-4.2-4.2 0-2.3 1.9-4.2 4.2-4.2 2.3 0 4.2 1.9 4.2 4.2 0 2.3-1.9 4.2-4.2 4.2zm0-6.5c-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2 1.2 0 2.2-1 2.2-2.2 0-1.2-1-2.2-2.2-2.2z"
})), React.createElement("path", {
  fill: "#9A9495",
  d: "M57.2 26.6L53 39.5l-4.5 14.1c-.3.8-1 1.4-1.9 1.4H2C.6 55-.3 53.7.1 52.4l6.1-19.1 2.5-7.9c.3-.8 1-1.4 1.9-1.4h44.6c1.4 0 2.4 1.3 2 2.6z"
}), React.createElement("circle", {
  cx: 29.2,
  cy: 40,
  r: 9,
  fill: "#FFF"
}), React.createElement("path", {
  fill: "#3D3234",
  d: "M33.2 39h-3v-3c0-.5-.5-1-1-1s-1 .5-1 1v3h-3c-.5 0-1 .5-1 1s.5 1 1 1h3v3c0 .5.5 1 1 1s1-.5 1-1v-3h3c.5 0 1-.5 1-1s-.4-1-1-1z"
}));

var SvgAddPhoto = function SvgAddPhoto(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 58,
    height: 55,
    viewBox: "0 0 58 55",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddPhoto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddPhoto.dce9430c.svg";
export { ForwardRef as ReactComponent };